import { gql } from "@apollo/client";

export const CONTACT_CORE_FIELDS = gql`
  fragment ContactCoreFields on contacts {
    id
    name
    number
  }
`;
